import { cn } from "~/lib/utils";
import CloseSvg from "@icons/Close";

interface Props {
  onClose: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  className?: string;
}

export default function CloseButton({
  onClose,
  disabled = false,
  className,
}: Props) {
  return (
    <button
      onClick={onClose}
      aria-label="Close"
      disabled={disabled}
      className={cn(
        "h-8 w-8 flex justify-center items-center bg-lightGrey rounded-full",
        { "opacity-40": disabled },
        className,
      )}
      data-testid="modal-close-button"
    >
      <CloseSvg />
    </button>
  );
}
